import { render, staticRenderFns } from "./new-demo.vue?vue&type=template&id=17904746&scoped=true&"
import script from "./new-demo.vue?vue&type=script&lang=js&"
export * from "./new-demo.vue?vue&type=script&lang=js&"
import style0 from "./new-demo.vue?vue&type=style&index=0&id=17904746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17904746",
  null
  
)

export default component.exports